export default class NodejsFileAdapter {
  static adapt(data) {
    if (!data) {
      return data;
    }

    if (!data.properties) {
      data.properties = {};
    }

    if (!data.properties.tenantMode) {
      data.properties.tenantMode = 'multi';
    }

    if (!data.properties.defaultLanguage) {
      data.properties.defaultLanguage = 'en';
    }

    if (!data.entities) {
      data.entities = [];
    }

    if (!data.relationships) {
      data.relationships = [];
    }

    data.entities.forEach((entity) => {
      if (!entity.fields) {
        entity.fields = [];
      }

      entity.fields.forEach((field) => {
        if (!field.properties) {
          field.properties = {};
        }

        if (!field.properties.exportable) {
          field.properties.exportable = 'yes';
        }
      });
    });

    return data;
  }
}
